import React from "react";
import ReactDOM from "react-dom";
const modalRoot = document.getElementById("modal-root");
const ModalContext = React.createContext();
export class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modals: [],
    };
  }

  openModal = (modal) => {
    this.setState((prev) => ({
      modals: [...prev.modals, modal],
    }));
  };

  closeModal = () => {
    this.setState((prev) => ({
      modals: prev.modals.slice(0, -1),
    }));
  };

  render() {
    return (
      <ModalContext.Provider
        value={{
          ...this.state,
          openModal: this.openModal,
          closeModal: this.closeModal,
        }}>
        {this.props.children}
      </ModalContext.Provider>
    );
  }
}

export class ModalPanel extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
  }
  componentDidMount() {
    modalRoot.appendChild(this.el);
  }
  componentWillUnmount() {
    modalRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      <ModalContext.Consumer>
        {(context) =>
          context.modals.map((modal, index) => (
            <React.Fragment key={index}>{modal}</React.Fragment>
          ))
        }
      </ModalContext.Consumer>,
      this.el
    );
  }
}

export class ModalControl extends React.Component {
  render() {
    return (
      <ModalContext.Consumer>
        {(context) => this.props.children(context)}
      </ModalContext.Consumer>
    );
  }
}
